import { createContext } from 'react';
var LocaleContext = /*#__PURE__*/createContext(undefined);
export default LocaleContext;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-locale/src/locale-context.js